import { useCallback, useEffect, useState } from 'react'
import { motion } from 'motion/react'
import { ContentPanel } from './ContentPanel'
import { FiltersPanel } from './FiltersPanel'
import { LoadingComponent } from '@/ui/Loading/LoadingComponent'
import { HourglassRegular } from '@fluentui/react-icons'
import { TileGrid } from './ContentPanel/TileGrid'
import { PageHeader } from './ContentPanel/PageHeader'
import { HeaderFilters } from './ContentPanel/HeaderFilters'
import { HeaderActions } from './ContentPanel/HeaderActions'
import { FiltersLayoutProvider } from './FiltersLayoutContext'

export function AppPage2() {
  return (
    <FiltersLayoutProvider>
      <AppPageContent />
    </FiltersLayoutProvider>
  )
}

function AppPageContent() {
  const [showFilters, setShowFilters] = useState(false)
  const [isConfiguringLayout, setIsConfiguringLayout] = useState(false)

  const toggleIsConfiguringLayout = useCallback(
    () => setIsConfiguringLayout(!isConfiguringLayout),
    [isConfiguringLayout]
  )
  const toggleShowFilters = useCallback(() => setShowFilters(!showFilters), [showFilters])

  useEffect(() => {
    if (isConfiguringLayout) {
      setShowFilters(true)
      return
    }
    setShowFilters(false)
  }, [isConfiguringLayout])

  return (
    /* Page container */
    <motion.div layout className="flex h-full w-full">
      <ContentPanel>
        <PageHeader>
          <HeaderFilters isConfiguringLayout={isConfiguringLayout} />

          <HeaderActions
            isConfiguringLayout={isConfiguringLayout}
            toggleIsConfiguringLayout={toggleIsConfiguringLayout}
            toggleShowFilters={toggleShowFilters}
          />
        </PageHeader>
        <TileGrid isConfiguringLayout={isConfiguringLayout} />
      </ContentPanel>
      <FiltersPanel
        showFilters={showFilters}
        toggleShowFilters={toggleShowFilters}
        isConfiguringLayout={isConfiguringLayout}
      />
    </motion.div>
  )
}

export function AppPageLoading() {
  return <LoadingComponent icon={<HourglassRegular fontSize={96} />} />
}
